




import { Component, Prop } from "vue-property-decorator";
import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";

@Component({})

export default class BorderlessText extends BaseBorderless {
    @Prop({ default: "text" }) type: "text" | "email" | "password"
}

